import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "anil-seat",
  props: {
    seatData: {
      type: Array
    },
    max: {
      type: Number,
      default: 1
    },
    title: {
      type: String,
      default: ''
    },
    info: {
      type: String,
      default: ''
    },
    address: {
      type: String,
      default: ''
    },
    roomName: {
      type: String,
      default: ''
    },
    statusList: {
      type: Array
    },
    activityAuditStatus: {
      type: Number,
      default: ''
    }
  },
  data: function data() {
    return {
      areaList: [],
      mySeatData: [],
      scaleMin: 1,
      //h5端为解决1无法缩小问题，设为0.95
      boxWidth: 1200,
      //屏幕宽度px
      space: ' ',
      //空格
      seatArray: [],
      //影院座位的二维数组,-1为非座位，0为未购座位，1为已选座位(绿色),2为已购座位(红色),一维行，二维列
      seatRow: 0,
      //影院座位行数
      seatCol: 0,
      //影院座位列数
      seatSize: 34,
      //座位尺寸
      SelectNum: 0,
      //选择座位数
      moveX: 0,
      //水平移动偏移量
      scale: 1,
      //放大倍数
      minRow: 0,
      //从第几行开始排座位
      minCol: 0,
      //从第几列开始排座位
      showTis: true,
      //显示选座提示
      seatList: [],
      //接口获取的原始位置
      mArr: [],
      //排数提示
      optArr: [],
      //选中的座位数组。
      isWXAPP: false,
      areaResult: []
    };
  },
  watch: {
    statusList: function statusList(val) {
      this.areaResult = [];
      this.areaList = val;
    },
    seatData: function seatData(val) {
      var _this = this;

      this.mySeatData = val;
      this.$nextTick(function () {
        _this.initData();
      });
    }
  },
  computed: {
    aPrice: function aPrice() {
      var totalAmount = '';

      if (this.optArr && this.optArr.length) {
        totalAmount = this.optArr.map(function (item) {
          return Number(item.Price);
        }).reduce(function (prev, curr) {
          return prev + curr;
        });
      }

      return totalAmount;
    },
    showEdit: function showEdit() {
      if (this.activityAuditStatus == 0) {
        return true;
      }

      return false;
    } // rpxNum () {
    //   return this.boxWidth / 750
    // },
    // pxNum () {
    //   return 750 / this.boxWidth
    // },

  },
  created: function created() {
    this.mySeatData = this.seatData;
    this.initData();
  },
  mounted: function mounted() {
    this.handleResize();
  },
  methods: {
    initData: function initData() {
      this.resetSeat();
      this.resetArea();

      if (this.mySeatData.length == 0) {
        return;
      }

      var arr = this.mySeatData; //假数据说明：SeatCode座位编号，RowNum-行号，ColumnNum-纵号，YCoord-Y坐标，XCoord-X坐标，Status-状态

      var row = 0;
      var col = 0;
      var minCol = parseInt(arr[0].X);
      var minRow = parseInt(arr[0].Y);

      var _iterator = _createForOfIteratorHelper(arr),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var i = _step.value;
          minRow = parseInt(i.Y) < minRow ? parseInt(i.Y) : minRow;
          minCol = parseInt(i.X) < minCol ? parseInt(i.X) : minCol;
          row = parseInt(i.Y) > row ? parseInt(i.Y) : row;
          col = parseInt(i.X) > col ? parseInt(i.X) : col;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.seatList = arr;
      this.seatRow = row - minRow + 1;
      this.seatCol = col - minCol + 3;
      this.minRow = minRow;
      this.minCol = minCol - 1;
      this.initSeatArray();
    },
    changeSeatStatus: function changeSeatStatus(status) {
      if (this.optArr.length == 0 && this.areaResult.length == 0) {
        this.$message.error('请选择区域或座位');
        return;
      }

      var obj = null;

      if (this.optArr.length > 0) {
        obj = {
          type: 'seat',
          status: status,
          id: this.optArr[0].id
        };
      } else if (this.areaResult.length > 0) {
        obj = {
          type: 'area',
          status: status,
          areaId: this.areaResult[0].areaId,
          actiItemId: this.areaResult[0].activityItemId
        };
      }

      this.$emit('seatStatus', obj);
    },
    setUnit: function setUnit(num, type) {
      var data = '';
      data = type == "row" ? this.endswith(num, "排") ? num : num + "排" : this.endswith(num, "座") ? num : num + "座";
      return data;
    },
    endswith: function endswith(string, substring) {
      var _str = string + ''; // 获取字符串的最后一个字符


      var lastChar = _str.substring(_str.length - 1, _str.length); // 检查这个字符是否包含指定的子字符串


      return lastChar.includes(substring);
    },
    //初始座位数组
    initSeatArray: function initSeatArray() {
      var _this2 = this;

      var seatArray = Array(this.seatRow).fill(0).map(function () {
        return Array(_this2.seatCol).fill({
          type: -1,
          id: '',
          R: '',
          C: '',
          A: '',
          status: -1
        });
      });
      this.seatArray = seatArray;
      this.seatSize = this.boxWidth > 0 ? parseInt(parseInt(this.boxWidth, 10) / (this.seatCol + 1), 10) : parseInt(parseInt(414, 10) / (this.seatCol + 1), 10);
      this.initNonSeatPlace();
    },
    //初始化是座位的地方
    initNonSeatPlace: function initNonSeatPlace() {
      var seat = this.seatList.slice();
      var arr = this.seatArray.slice();

      for (var num in seat) {
        var status = 2; //-1为非座位，0为未购座位，1为已选座位(绿色),2为已购座位(红色)

        if (seat[num].S == 0) {
          status = 0;
        } else if (seat[num].S == -1) {
          status = -1;
        } else if (seat[num].S == 3) {
          status = 3;
        }

        arr[parseInt(seat[num].Y) - this.minRow][parseInt(seat[num].X) - this.minCol] = {
          type: status,
          id: seat[num].id,
          R: seat[num].R,
          C: seat[num].C,
          P: seat[num].P,
          A: seat[num].A,
          status: status
        };
      }

      this.seatArray = arr.slice();
      var mArr = [];

      for (var i in arr) {
        var m = '';

        var _iterator2 = _createForOfIteratorHelper(arr[i]),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var n = _step2.value;

            if (n.id) {
              m = n.R;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        if (m) {
          mArr.push(m);
        } else {
          mArr.push('');
        }
      }

      this.mArr = mArr;
    },
    getDialogWidth: function getDialogWidth() {
      var width = this.$refs.dialogRef.offsetWidth;
      return width;
    },
    handleResize: function handleResize() {
      this.boxWidth = this.getDialogWidth();
      this.scaleMin = 0.95; // 在这里可以执行其他与宽度变化相关的逻辑
    },
    createSeat: function createSeat(type, name) {
      var _this3 = this;

      this.$confirm("\u4F60\u786E\u5B9A".concat(name, "?\u8BE5\u64CD\u4F5C\u5C06\u4F1A\u91CD\u65B0\u751F\u6210\u6570\u636E, \u662F\u5426\u7EE7\u7EED?"), '提示').then(function () {
        _this3.$emit('createSeat', {
          type: type
        });

        _this3.resetSeat();

        _this3.resetArea();
      });
    },
    //放大缩小事件
    onScale: function onScale(e) {
      this.showTis = false; // this.moveX=-e.detail.x

      var w = this.boxWidth * 0.5;
      var s = 1 - e.detail.scale;
      this.moveX = w * s;
      this.scale = e.detail.scale;

      if (s > -0.5 || s == 0) {
        this.showTis = true;
      }
    },
    //移动事件
    onMove: function onMove(e) {
      this.showTis = false;
      this.moveX = e.detail.x;
    },
    //重置座位
    resetSeat: function resetSeat() {
      this.SelectNum = 0;
      this.optArr = []; //将所有已选座位的值变为0

      var oldArray = this.seatArray.slice();

      for (var i = 0; i < this.seatRow; i++) {
        for (var j = 0; j < this.seatCol; j++) {
          if (oldArray[i][j].type == 1) {
            oldArray[i][j].type = 0;
          }
        }
      }

      this.seatArray = oldArray;
    },
    resetArea: function resetArea() {
      this.areaResult = [];
      this.areaList = JSON.parse(JSON.stringify(this.statusList));
    },
    //选定且购买座位
    buySeat: function buySeat() {
      if (this.SelectNum == 0) return; // let oldArray = [];
      // for (let i = 0; i < this.seatRow; i++) {
      // 	for (let j = 0; j < this.seatCol; j++) {
      // 		if (this.seatArray[i][j].type == 1) {
      // 			oldArray.push(this.seatArray[i][j])
      // 		}
      // 	}
      // }

      this.$emit('confirm', this.optArr);
    },
    selectArea: function selectArea(item, index) {
      if (!this.showEdit) {
        return;
      }

      this.resetSeat();

      if (item.areaType == 0) {
        if (this.areaResult.length > 0) {
          this.$message.error("最多只能选一个区域");
          return;
        }

        this.$set(this.areaList[index], "areaType", 1);

        for (var ix = 0; ix < this.areaList.length; ix++) {
          var element = this.areaList[ix];

          if (this.areaResult.length == 0 && element.areaType == 1) {
            this.areaResult.push(element);
          }
        }
      } else {
        this.areaResult.pop();
        this.$set(this.areaList[index], "areaType", 0);
      }
    },
    //处理座位选择逻辑
    handleChooseSeat: function handleChooseSeat(row, col) {
      if (!this.showEdit) {
        return;
      }

      this.resetArea();
      var seatValue = this.seatArray[row][col].type;
      var newArray = this.seatArray; //如果是已购座位，直接返回

      if (seatValue == 2 || seatValue == -1) return; //如果是已选座位点击后变未选

      if (seatValue == 1) {
        newArray[row][col].type = this.seatArray[row][col].status;
        this.SelectNum--;
        this.getOptArr(newArray[row][col], 0);
      } else if (seatValue == 0 || seatValue == 3) {
        if (this.SelectNum >= this.max) {
          return this.$message.error('一次最多选择' + this.max + '个座位');
        }

        newArray[row][col].rowIndex = row;
        newArray[row][col].colIndex = col;
        newArray[row][col].type = 1;
        this.SelectNum++;
        this.getOptArr(newArray[row][col], 1);
      } //必须整体更新二维数组，Vue无法检测到数组某一项更新,必须slice复制一个数组才行


      this.seatArray = newArray.slice();
    },
    //处理已选座位数组
    getOptArr: function getOptArr(item, type) {
      var optArr = this.optArr;

      if (type == 1) {
        optArr.push(item);
      } else if (type == 0) {
        var arr = [];
        optArr.forEach(function (v) {
          if (v.id !== item.id) {
            arr.push(v);
          }
        });
        optArr = arr;
      }

      this.optArr = optArr.slice();
    },
    //推荐选座,参数是推荐座位数目，
    smartChoose: function smartChoose(num) {
      // 先重置
      this.resetSeat(); //找到影院座位水平垂直中间位置的后一排

      var rowStart = parseInt((this.seatRow - 1) / 2, 10) + 1; //先从中间排往后排搜索

      var backResult = this.searchSeatByDirection(rowStart, this.seatRow - 1, num);

      if (backResult.length > 0) {
        this.chooseSeat(backResult);
        this.SelectNum += num;
        return;
      } //再从中间排往前排搜索


      var forwardResult = this.searchSeatByDirection(rowStart - 1, 0, num);

      if (forwardResult.length > 0) {
        this.chooseSeat(forwardResult);
        this.SelectNum += num;
        return;
      } //提示用户无合法位置可选
      // #ifdef H5


      alert('无合法位置可选!'); // #endif
    },
    //搜索函数,参数:fromRow起始行，toRow终止行,num推荐座位数
    searchSeatByDirection: function searchSeatByDirection(fromRow, toRow, num) {
      /*
       * 推荐座位规则
       * (1)初始状态从座位行数的一半处的后一排的中间开始向左右分别搜索，取离中间最近的，如果满足条件，
       *    记录下该结果离座位中轴线的距离，后排搜索完成后取距离最小的那个结果座位最终结果，优先向后排进行搜索，
       *    后排都没有才往前排搜，前排逻辑同上
       *
       * (2)只考虑并排且连续的座位，不能不在一排或者一排中间有分隔
       *
       * */

      /*
       * 保存当前方向搜索结果的数组,元素是对象,result是结果数组，offset代表与中轴线的偏移距离
       * {
       *   result:Array([x,y])
       *   offset:Number
       * }
       *
       */
      var currentDirectionSearchResult = [];
      var largeRow = fromRow > toRow ? fromRow : toRow,
          smallRow = fromRow > toRow ? toRow : fromRow;

      for (var i = smallRow; i <= largeRow; i++) {
        //每一排的搜索,找出该排里中轴线最近的一组座位
        var tempRowResult = [],
            minDistanceToMidLine = Infinity;

        for (var j = 0; j <= this.seatCol - num; j++) {
          //如果有合法位置
          if (this.checkRowSeatContinusAndEmpty(i, j, j + num - 1)) {
            //计算该组位置距离中轴线的距离:该组位置的中间位置到中轴线的距离
            var resultMidPos = parseInt(j + num / 2, 10);
            var distance = Math.abs(parseInt(this.seatCol / 2) - resultMidPos); //如果距离较短则更新

            if (distance < minDistanceToMidLine) {
              minDistanceToMidLine = distance; //该行的最终结果

              tempRowResult = this.generateRowResult(i, j, j + num - 1);
            }
          }
        } //保存该行的最终结果


        currentDirectionSearchResult.push({
          result: tempRowResult,
          offset: minDistanceToMidLine
        });
      } //处理后排的搜索结果:找到距离中轴线最短的一个
      //注意这里的逻辑需要区分前后排，对于后排是从前往后，前排则是从后往前找


      var isBackDir = fromRow < toRow;
      var finalReuslt = [],
          minDistanceToMid = Infinity;

      if (isBackDir) {
        //后排情况,从前往后
        currentDirectionSearchResult.forEach(function (item) {
          if (item.offset < minDistanceToMid) {
            finalReuslt = item.result;
            minDistanceToMid = item.offset;
          }
        });
      } else {
        //前排情况，从后往前找
        currentDirectionSearchResult.reverse().forEach(function (item) {
          if (item.offset < minDistanceToMid) {
            finalReuslt = item.result;
            minDistanceToMid = item.offset;
          }
        });
      } //直接返回结果


      return finalReuslt;
    },

    /*辅助函数，判断每一行座位从i列到j列是否全部空余且连续
     *
     */
    checkRowSeatContinusAndEmpty: function checkRowSeatContinusAndEmpty(rowNum, startPos, endPos) {
      var isValid = true;

      for (var i = startPos; i <= endPos; i++) {
        if (this.seatArray[rowNum][i].type !== 0) {
          isValid = false;
          break;
        }
      }

      return isValid;
    },
    //辅助函数：返回每一行的某个合理位置的座位数组
    generateRowResult: function generateRowResult(row, startPos, endPos) {
      var result = [];

      for (var i = startPos; i <= endPos; i++) {
        result.push([row, i]);
      }

      return result;
    },
    //辅助函数:智能推荐的选座操作
    chooseSeat: function chooseSeat(result) {
      var opt = this.optArr;
      var oldArray = this.seatArray.slice();

      for (var i = 0; i < result.length; i++) {
        //选定座位
        oldArray[result[i][0]][result[i][1]].rowIndex = result[i][0];
        oldArray[result[i][0]][result[i][1]].colIndex = result[i][1];
        oldArray[result[i][0]][result[i][1]].type = 1;
        this.optArr.push(oldArray[result[i][0]][result[i][1]]);
      }

      this.seatArray = oldArray;
    }
  }
};